import { Component, DestroyRef, inject, ChangeDetectionStrategy, signal, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ButtonModule } from 'primeng/button';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { User, UserStateService } from 'riterz-core';
import { VerifyEmailComponent } from '../verify-email/verify-email.component';
import { OrganizationSubmitComponent } from '../organization-submit/organization-submit.component';

@Component({
  selector: 'rt-welcome',
  imports: [
    ButtonModule
  ],
  standalone: true,
  templateUrl: './welcome.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WelcomeComponent implements OnInit {
  private dialogConfig = inject(DynamicDialogConfig);
  private dialogRef = inject(DynamicDialogRef);
  private dialogService = inject(DialogService);
  private userStateService = inject(UserStateService);
  private destroyRef = inject(DestroyRef);

  readonly currentUser = signal<User|null>(null);
  readonly name = signal<string>('');
  readonly email = signal<string>('');
  readonly verified = signal<boolean>(false);

  ngOnInit(): void {
    if (this.dialogConfig.data?.email) {
      this.email.set(this.dialogConfig.data.email);
    }

    if (this.dialogConfig.data?.name) {
      this.name.set(this.dialogConfig.data.name);
    }

    if (this.dialogConfig.data?.verified) {
      this.verified.set(this.dialogConfig.data.verified);
    }

    // Read the shared subject — AppComponent already loaded the user with its relations.
    this.userStateService
      .currentUser
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((user) => {
        this.currentUser.set(user);
      });
  }

  public openProfileForm(): void {
    if (!this.currentUser()) { return; } 
    
    if (!this.currentUser()?.email_verified_at) {
      this.dialogService.open(VerifyEmailComponent, {
        header: 'Verify Email',
        width: '40rem',
      });
      return;
    }

    this.dialogService.open(OrganizationSubmitComponent, {
      header: 'Profile Submission',
      width: '40rem',
      closable: true,
      modal: true
    });
  }

  public close(): void {
    this.dialogRef.close({ hasChanges: false });
  }
}
